import React, {Component} from 'react';
import {keyBy} from 'lodash';
import {connect} from 'react-redux';
import DatePicker from 'react-datepicker';
import {Card, Header, Radio, Form, Input, Button, Select, Label} from 'semantic-ui-react';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {dateFormatPicker, reverseShortDate} from '../../../common/constants/datesFormat';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {convertDateToSpecificFormat} from '../../../common/util/date';
import {paths} from '../../../common/dictionaries/urls';
import {WARRANTIES_TYPES} from '../../constants';
import {Actions} from '../../../common/actions';
import Loader from '../../../common/components/loader';
import QueryTable from './Table';

const TYPE_SEARCH = {
  'SINGLE': 'S',
  'MANY': 'M',
};

const SearchFormSingle = ({chassis, invoice, twc, handleChange}) => {
  return (
    <React.Fragment>
      <Form.Field
        value={chassis}
        control={Input}
        label='VIN Chasis'
        placeholder='Chasis'
        onChange={(e, {value}) => handleChange('chassis', value)}
      />
      <Form.Field
        value={invoice}
        control={Input}
        label='Cuenta de cobro Concesionario'
        placeholder='Cuenta de cobro concesionario'
        onChange={(e, {value}) => handleChange('invoice', value)}
      />
      <Form.Field
        value={twc}
        control={Input}
        label='Número Twc Concesionario'
        placeholder='Número Twc concesionario'
        onChange={(e, {value}) => handleChange('twc', value)}
      />
    </React.Fragment>
  );
};


const SearchFormMany = ({statusSelect, handleChange, initDate, endDate, typeTwc, status}) => {
  return (
    <React.Fragment>
      <Form.Input fluid label='Fecha de inicial'>
        <DatePicker
          placeholderText='Fecha de inicial'
          className='tcc-datepicker'
          showYearDropdown
          selected={initDate}
          dateFormat={dateFormatPicker}
          onChange={(value) => handleChange('initDate', value)}
          locale='es'
        />
      </Form.Input>
      <Form.Input fluid label='Fecha de final'>
        <DatePicker
          placeholderText='Fecha de final'
          className='tcc-datepicker'
          showYearDropdown
          selected={endDate}
          dateFormat={dateFormatPicker}
          minDate={initDate}
          onChange={(value) => handleChange('endDate', value)}
          locale='es'
        />
      </Form.Input>
      <Form.Field
        control={Select}
        options={statusSelect}
        label='Estado'
        placeholder='Estado'
        value={status}
        onChange={(e, {value}) => handleChange('status', value)}
      />
      <Form.Field
        control={Select}
        options={WARRANTIES_TYPES}
        label='Tipo'
        placeholder='Tipo'
        value={typeTwc}
        onChange={(e, {value}) => handleChange('typeTwc', value)}
      />
    </React.Fragment>
  );
};


const blackFieldSingleSearch = (field, value) => {
  const searchObject = {
    'singleSearch': value,
    field,
  };

  if (field === 'chassis') {
    return {
      'invoice': '',
      'twc': '',
      ...searchObject,
    };
  } else if (field === 'invoice') {
    return {
      'chassis': '',
      'twc': '',
      ...searchObject,
    };
  } else if (field === 'twc') {
    return {
      'chassis': '',
      'invoice': '',
      ...searchObject,
    };
  }
  return {};
};


class WarrantyQuery extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'chassis': '',
      'invoice': '',
      'twc': '',
      'singleSearch': '',
      'typeSearch': 'S',
      'initDate': null,
      'endDate': null,
      'typeTwc': 'TODOS',
      'status': 'TODOS',
      'filteredRows': [],
    };
  }

  componentDidMount() {
    if (!hasAccessPermission(this.props.permissions, resources.WarrantyQuery, scopes.See)) {
      this.props.navigateTo(paths.AccessDenied);
    }
    this.props.clearWarranties();
    this.props.getWarrantiesStatus();
  }

  handleChange = (field, value) => {
    this.setState({
      [field]: value,
      ...blackFieldSingleSearch(field, value),
    });
  }

  handleChangeInput = (field, value) => {
    this.setState({
      [field]: value,
      'chassis': '',
      'invoice': '',
      'twc': '',
      'singleSearch': '',
      'initDate': null,
      'endDate': null,
      'typeTwc': 'TODOS',
      'status': 'TODOS',
    });
  }


  handleSearch = () => {
    const {typeSearch, field, singleSearch, initDate, endDate, typeTwc, status} = this.state;
    const parseInitDate = convertDateToSpecificFormat(initDate, reverseShortDate);
    const parseEndDate = convertDateToSpecificFormat(endDate, reverseShortDate);
    const {dealer} = this.props;
    const params = typeSearch === 'S' ? `&${field}=${singleSearch}` :
      `&initDate=${parseInitDate}&endDate=${parseEndDate}&typeTwc=${typeTwc}&status=${status}`;

    this.props.getWarrantiesByFilter(typeSearch, dealer, params);
  }

  render() {
    const {typeSearch, singleSearch, initDate, endDate, filteredRows} = this.state;
    const {warranties, loading, statusLoading, statusList, statusSelect, permissions, dealer} = this.props;
    const validateSingleSearch = singleSearch.length <= 2;
    const validateManySearch = initDate === null || endDate === null;

    if (statusLoading) {
      return <div className="twc-loader-container">
        <Loader/>
      </div>;
    }

    return (
      <div className='warranty-container'>
        <Card raised fluid>
          <div className='warranty-container-header'>
            <Header as='h2'>Consulta de Garantías</Header>
            <Label className='warranty-total' color='red'>
              Total garantías
              <Label.Detail>{filteredRows.length}</Label.Detail>
            </Label>
          </div>
        </Card>
        <Card raised fluid>
          <div className='twc-search-container'>
            <Form>
              <label className='invoice-b-10'>Busqueda de garantías</label>
              <Form.Group widths='twelve'>
                <Form.Field
                  control={Radio}
                  label='Por parámetro'
                  value='S'
                  checked={typeSearch === TYPE_SEARCH.SINGLE}
                  onChange={(e, {value}) =>
                    this.handleChangeInput('typeSearch', value)
                  }
                />
                <Form.Field
                  control={Radio}
                  label='Por rangos de fecha y tipo'
                  value='M'
                  checked={typeSearch === TYPE_SEARCH.MANY}
                  onChange={(e, {value}) =>
                    this.handleChangeInput('typeSearch', value)
                  }
                />
              </Form.Group>
              <Form.Group widths='equal'>
                {typeSearch === 'S' ? (
                  <SearchFormSingle
                    {...this.state}
                    handleChange={this.handleChange}
                  />
                ) : (
                  <SearchFormMany
                    {...this.state}
                    statusSelect={statusSelect}
                    handleChange={this.handleChange}
                  />
                )}
                <div className='twc-btn-search'>
                  <Button
                    disabled={
                      typeSearch === 'S' ?
                        validateSingleSearch :
                        validateManySearch
                    }
                    onClick={this.handleSearch}
                    type='submit'
                    color='green'
                  >
                    BUSCAR
                  </Button>
                </div>
              </Form.Group>
            </Form>
          </div>
        </Card>
        {loading ? (
          <div className='twc-loader-container'>
            <Loader />
          </div>
        ) : (
          <Card raised fluid className=''>
            <QueryTable
              warranties={warranties}
              statusList={statusList}
              handleChange={this.handleChange}
              filteredRows={filteredRows}
              permissions={permissions}
              dealer={dealer}
            />
          </Card>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const status = keyBy(state.warrantiesStatus.list, 'status');
  const statusSelect = state.warrantiesStatus.list.map((item) => ({
    'key': item.status, 'text': item.description.toUpperCase(), 'value': item.status,
  }));
  statusSelect.unshift({'key': 'TODOS', 'text': 'TODOS', 'value': 'TODOS'});

  return {
    'permissions': state.session.permissions,
    'dealer': state.session.dealerId,
    'warranties': state.warrantiesList.list,
    'loading': state.warrantiesList.loading,
    'status': state.warrantiesStatus.list,
    'statusLoading': state.warrantiesStatus.loading,
    'statusList': status,
    statusSelect,
  };
};

const {
  getWarrantiesByFilter,
  getWarrantiesStatus,
  clearWarranties,
  navigateTo,
  withRouter,
} = Actions;

export default withRouter(connect(mapStateToProps, {
  getWarrantiesByFilter,
  getWarrantiesStatus,
  clearWarranties,
  navigateTo,
})(WarrantyQuery));
